/**
 * JW PLayer directive for
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.directive('lmJwplayer', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    link: function (scope, element, attrs) {
      scope.url = attrs['url'];
      scope.link = attrs['link'];
      scope.noCloseButton = attrs['noCloseButton'];
      scope.hlshtml = false;

      scope.isPlayableSource = function (stream) {

        return stream.is_deployed && ['hls', 'hls_live', 'dash', 'dash_live'].indexOf(stream.stream_type) !== -1;
      };

      jwplayer.key = "BITOrqayHBu4KX9aaS5KfhRISCfjrp1g5fZTlw==";

      var modes = ['uniform', 'fill', 'exactfit', 'none '];
      var current = -1;

      var getStretch = function () {
        return modes[current + 1] ? modes[current + 1] : modes[0];
      };

      var getNextStretch = function () {
        current += 1;

        if (!modes[current]) {
          current = 0;
        }

        return modes[current];
      };

      var init = function () {
        scope.playbackError = '';

        jwplayer("player_id").setup({
          dash: true,
          playlist: {sources: [{file: scope.url, withCredentials: true}]},
          //file: 'http://demo.noisypeak.com/output/discoveryscience_dash/output.mpd',
          stretching: getNextStretch(),
          skin: {
            name: 'glow'
          },
          image: "/images/sotal_cloud_big_banner.png",
          //advertising: {
          //  client: "vast",
          //  schedule: {"myAds": {"offset": "50", "tag": "https://servedbyadbutler.com/vast.spark?setID=2112&ID=167635&pid=22810", type: "nonlinear"}}
          //},
          //logo: {
          //  file: '/images/sotal_cloud_player_logo.png',
          //  margin: '25',
          //  position: 'top-left'
          //},
          hlshtml: scope.hlshtml,
          primary: 'html5',
          volume: '0',
          autostart: 'true',
          height: "360",
          width: "640"
        });

        jwplayer('player_id').on('error', function (error) {
          scope.$apply(function () {
            scope.playbackError = error.message;
          });
          jwplayer('player_id').play();
          console.log('Error: ', error);
        });

        jwplayer('player_id').on('ready', function () {
          scope.$apply(function () {
            scope.playbackError = '';
          });

          var $element = $('<div/>');

          $element[0].id = 'banner_div';
          $element.append('<img src="/images/sotal_cloud_player_logo.png" />');

          $('.jw-overlays.jw-reset').append($element);
        });

        jwplayer('player_id').addButton(
          //This portion is what designates the graphic used for the button
          "/images/settings_white.png",
          //This portion determines the text that appears as a tooltip
          'Use "' + (getStretch().toUpperCase()) + '"',
          //This portion designates the functionality of the button itself
          function () {
            //With the below code, we're grabbing the file that's currently playing
            $timeout(function () {
              init();
            }, 350);
          },
          //And finally, here we set the unique ID of the button itself.
          "stretch"
        );
      };

      init();

      var experimentalFeatureWatcher = scope.$watch('hlshtml', function (newV, oldV) {
        if (newV !== oldV) {

          jwplayer("player_id").remove();
          init();
        }
      });

      var urlWatcher = scope.$watch('url', function (newV, oldV) {
        if (newV !== oldV) {
          scope.playbackError = '';

          var playlist = [{sources: [{file: newV, withCredentials: true}]}];
          jwplayer("player_id").load(playlist);
        }
      });

      var linkWatcher = scope.$watchCollection('link', function (newValue) {
        if (newValue === undefined) return;
        scope.playbackError = '';
        scope.url = newValue;
        var playlist = [{sources: [{file: newValue, withCredentials: true}]}];
        jwplayer("player_id").load(playlist);
        init();
      });


      element.on('$destroy', function () {
        jwplayer("player_id").remove();
        experimentalFeatureWatcher();
        urlWatcher();
        linkWatcher();
      });
    },
    templateUrl: 'lm-jwplayer/jw-player.tpl.html'
  };
}]);
